import { ChevronLeft, Search, X } from 'lucide-react';

// Společné kousky řízené dokumentace v Cockpitu (mobil). Vzhled drží karty
// Notifikací a Osobního rozvoje, ať sekce nepůsobí jako cizí modul.

export const TYRKYS = '#0CC0DF';   // směrnice (skupina Provoz)
export const ORANZOVA = 'var(--brand)'; // recepty
export const FIALOVA = '#B47AEA';  // polotovar

export const csrf = () => document.querySelector('meta[name="csrf-token"]')?.content;

export const bezDiakritiky = (s) => (s || '').toString().toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');

export const datum = (d, rok = true) => d
    ? new Date(d).toLocaleDateString('cs-CZ', rok ? { day: 'numeric', month: 'numeric', year: 'numeric' } : { day: 'numeric', month: 'numeric' })
    : '';

export const styly = (isDark) => ({
    karta: {
        background: isDark ? 'rgba(255,255,255,0.055)' : 'var(--surface-raised)',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.10)' : 'var(--border-default)'}`,
        borderRadius: 12,
    },
    tlumenaKarta: {
        background: isDark ? 'rgba(255,255,255,0.03)' : 'var(--surface-raised)',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.07)' : 'var(--border-default)'}`,
        borderRadius: 12,
    },
    linka: isDark ? 'rgba(255,255,255,0.06)' : 'var(--border-subtle)',
    plocha: isDark ? 'rgba(255,255,255,0.07)' : 'var(--surface-elevated)',
});

// Nadpis skupiny (malé verzálky)
export function Nadpis({ children, barva }) {
    return (
        <p className="text-[10px] uppercase" style={{ color: barva || 'var(--text-secondary)', letterSpacing: '0.08em', fontWeight: 600, margin: '18px 0 8px' }}>
            {children}
        </p>
    );
}

// Zpět nad nadpisem obrazovky
export function Zpet({ label, onClick }) {
    return (
        <button onClick={onClick} className="flex items-center gap-0.5 text-[13px] font-semibold"
            style={{ color: 'var(--text-secondary)', background: 'none', cursor: 'pointer', padding: '2px 0', marginBottom: 2 }}>
            <ChevronLeft size={18} /> {label}
        </button>
    );
}

export function Hledani({ value, onChange, placeholder, isDark, autoFocus }) {
    return (
        <div className="flex items-center gap-2" style={{
            height: 42, borderRadius: 21, padding: '0 14px',
            background: isDark ? 'rgba(255,255,255,0.07)' : 'var(--surface-raised)',
            border: `1px solid ${value ? 'var(--brand)' : (isDark ? 'rgba(255,255,255,0.12)' : 'var(--border-default)')}`,
        }}>
            <Search size={17} style={{ color: value ? 'var(--brand)' : 'var(--text-muted)', flexShrink: 0 }} />
            <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} autoFocus={autoFocus}
                enterKeyHint="search" type="search"
                style={{ flex: 1, minWidth: 0, background: 'none', border: 'none', outline: 'none', fontSize: 15, color: 'var(--text-primary)' }} />
            {value && (
                <button onClick={() => onChange('')} aria-label="Smazat hledání" style={{ background: 'none', cursor: 'pointer', color: 'var(--text-muted)', display: 'flex' }}>
                    <X size={16} />
                </button>
            )}
        </div>
    );
}

// Posouvací obsah sekce — Přehled na mobilu drží výšku, scrolluje jen obsah
export function Posun({ children }) {
    return <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', overscrollBehavior: 'contain' }}>{children}</div>;
}

// Naposledy otevřené recepty — jen pohodlí v tomhle prohlížeči
const KLIC_NEDAVNE = 'dokumentace-nedavne-recepty';
export const nedavne = () => {
    try { return JSON.parse(localStorage.getItem(KLIC_NEDAVNE) || '[]'); } catch { return []; }
};
export const zapisNedavny = (r) => {
    try {
        const dalsi = [{ id: r.id, nazev: r.nazev, foto_url: r.foto_url }, ...nedavne().filter(x => x.id !== r.id)].slice(0, 5);
        localStorage.setItem(KLIC_NEDAVNE, JSON.stringify(dalsi));
    } catch { /* bez úložiště to jde i tak */ }
};
